/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Automation_Execute_Detail7Inputs */

const en_svc_automation_execute_detail7 = /** @type {(inputs: Svc_Automation_Execute_Detail7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Automate incrementally, starting at the highest-friction step.`)
};

const ar_svc_automation_execute_detail7 = /** @type {(inputs: Svc_Automation_Execute_Detail7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`أتمتة تدريجيًا مبتدئًا بالخطوة اليدوية الأكثر إرهاقًا.`)
};

const bn_svc_automation_execute_detail7 = /** @type {(inputs: Svc_Automation_Execute_Detail7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`সবচেয়ে ঝামেলার ধাপ থেকে শুরু করে ধাপে ধাপে অটোমেট করুন।`)
};

const de_svc_automation_execute_detail7 = /** @type {(inputs: Svc_Automation_Execute_Detail7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schrittweise automatisieren, beginnend beim aufwendigsten manuellen Schritt.`)
};

const es_svc_automation_execute_detail7 = /** @type {(inputs: Svc_Automation_Execute_Detail7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Automatice por pasos, empezando por el paso manual más pesado.`)
};

const fr_svc_automation_execute_detail7 = /** @type {(inputs: Svc_Automation_Execute_Detail7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Automatisez par étapes, en commençant par l'étape manuelle la plus coûteuse.`)
};

const pt_svc_automation_execute_detail7 = /** @type {(inputs: Svc_Automation_Execute_Detail7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Automatize por etapas, começando pela etapa manual mais pesada.`)
};

const zh_svc_automation_execute_detail7 = /** @type {(inputs: Svc_Automation_Execute_Detail7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`从最费人力的环节开始逐步自动化。`)
};

const tr_svc_automation_execute_detail7 = /** @type {(inputs: Svc_Automation_Execute_Detail7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En yorucu manuel adımdan başlayarak azar azar otomatikleştirin.`)
};

const ru_svc_automation_execute_detail7 = /** @type {(inputs: Svc_Automation_Execute_Detail7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Автоматизируйте постепенно, начиная с самого муторного ручного шага.`)
};

const pl_svc_automation_execute_detail7 = /** @type {(inputs: Svc_Automation_Execute_Detail7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Automatyzuj małymi krokami, zaczynając od najbardziej upierdliwego manuala.`)
};

/**
* | output |
* | --- |
* | "Automate incrementally, starting at the highest-friction step." |
*
* @param {Svc_Automation_Execute_Detail7Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_automation_execute_detail7 = /** @type {((inputs?: Svc_Automation_Execute_Detail7Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Automation_Execute_Detail7Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_automation_execute_detail7(inputs)
	if (locale === "bn") return bn_svc_automation_execute_detail7(inputs)
	if (locale === "de") return de_svc_automation_execute_detail7(inputs)
	if (locale === "es") return es_svc_automation_execute_detail7(inputs)
	if (locale === "fr") return fr_svc_automation_execute_detail7(inputs)
	if (locale === "pt") return pt_svc_automation_execute_detail7(inputs)
	if (locale === "zh") return zh_svc_automation_execute_detail7(inputs)
	if (locale === "tr") return tr_svc_automation_execute_detail7(inputs)
	if (locale === "ru") return ru_svc_automation_execute_detail7(inputs)
	if (locale === "pl") return pl_svc_automation_execute_detail7(inputs)
	return en_svc_automation_execute_detail7(inputs)
});
export { svc_automation_execute_detail7 as "svc_automation_EXECUTE_detail" }